import React from "react";

export default function BlogListAside(props) {
        return (
            <aside className="date">{props.category} <time>{props.date}</time></aside>
        );
}



// WEBPACK FOOTER //
// ./src/components/Containers/blogListAside.js